import * as React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLoaderData } from 'react-router-dom';

import { DiscountCodeFormContext } from 'context';
import type { ComponentMode, DiscountCode as DiscountCodeConfig } from 'types';

import { DiscountCodeForm, DiscountCodeHeader } from './components';

type DiscountCodeProps = {
  mode: ComponentMode;
};

export default function DiscountCode({ mode }: DiscountCodeProps) {
  const data = useLoaderData() as DiscountCodeConfig | undefined;

  const { code, enable } = data ?? {};
  const isUpdatedMode = mode === 'Update';

  const title = isUpdatedMode ? `کد تخفیف ${code}` : 'افزودن کد تخفیف جدید';
  const defaultEnable = isUpdatedMode ? Boolean(enable) : true;
  const defaultCode = isUpdatedMode ? code : '';

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${title} | کاشی لند`}</title>
      </Helmet>
      <DiscountCodeHeader>{title}</DiscountCodeHeader>
      <DiscountCodeFormContext
        mode={mode}
        defaultEnable={defaultEnable}
        defaultCode={defaultCode}
        {...(isUpdatedMode ? data : {})}
      >
        <DiscountCodeForm />
      </DiscountCodeFormContext>
    </React.Fragment>
  );
}
